<template>
    <div>
        <div class="m-filters">
            <single-select :items="categories"
                           :value="selectedCategory"
                           placeholder="Select category"
                           @select="changeCategory" />

            <single-select :items="subCategories"
                           :value="selectedSubCategory"
                           placeholder="Select sub-category"
                           @select="changeSubCategory" />

            <!--<multi-select :items="tags"
                          :value="filters.tags"
                          placeholder="Select theme" />-->

            <autocomplete :keywords="filters.keywords"
                          placeholder="Search keyword"
                          @select="changeKeywords" />

            <div class="m-filters__buttons">
                <filter-button icon="/assets/img/icons/favourite.svg"
                               text="Favourites"
                               :selected="filters.favourites"
                               @select="changeFavourites" />

                <filter-button icon="/assets/img/icons/gallery.svg"
                               text="Custom Image"
                               :selected="filters.customImage"
                               :disabled="!hasCustomImage"
                               @select="changeCustomImage" />

                <filter-button text="Custom Text"
                               :selected="filters.customText"
                               :disabled="!hasCustomText"
                               @select="changeCustomText" />

                <tooltip v-if="metaData.popupText" text="Info" :open="showPopup" @close="dismissPopup">
                    <h3 class="u-color-pink" v-html="metaData.popupTitle"></h3>
                    <div v-html="metaData.popupText"></div>
                </tooltip>
            </div>
        </div>

        <tag-list :tags="filters.tags"
                  @remove="removeTag"
                  @clearAll="clearAllTags" />
    </div>
</template>

<script>
    import autocomplete from "../components/autocomplete.vue";
    import filterButton from "../components/filter-button.vue";
    import multiSelect from "../components/multi-select.vue";
    import singleSelect from "../components/single-select.vue";
    import tagList from "../components/tag-list.vue";
    import tooltip from "../components/tooltip.vue";
    import searchStore from "../stores/search";

    export default {
        props: {
            filters: { type: Object },
            metaData: { type: Object }
        },
        data: function () {
            return {
                categories: [],
                tags: [],
                hasCustomImage: false,
                hasCustomText: false
            };
        },
        computed: {
            selectedCategory: function () {
                if (this.filters.categories) {
                    return this.filters.categories[0];
                }
            },
            selectedSubCategory: function () {
                if (this.filters.categories) {
                    return this.filters.categories[1];
                }
            },
            subCategories: function () {
                const category = this.categories.find(x => x.alias == this.selectedCategory);
                return category ? category.subCategories : [];
            },
            showPopup: function () {
                const popupState = JSON.parse(window.localStorage.getItem("popupState")) || [];
                return this.metaData && !!this.metaData.popupText && !popupState.includes(this.metaData.alias);
            }
        },
        methods: {
            loadFilters: function () {
                searchStore.filters(this.filters.types, this.filters.culture)
                    .then(res => {
                        this.categories = res.data.categories;
                        this.tags = res.data.tags;
                        this.hasCustomImage = res.data.customImage;
                        this.hasCustomText = res.data.customText;
                    });
            },
            changeCategory: function (value) {
                this.setCategory(value);
            },
            changeSubCategory: function (value) {
                this.setCategory(this.selectedCategory, value);
            },
            setCategory: function (category, subCategory) {
                if (category && subCategory) {
                    this.filters.categories = [category, subCategory];
                } else if (category) {
                    this.filters.categories = [category];
                } else {
                    this.filters.categories = [];
                }
                this.updateQueryString("category", category);
                this.updateQueryString("sub-category", subCategory);
            },
            removeTag: function (value) {
                const position = this.filters.tags.indexOf(value);
                if (position > -1) {
                    // update watched values
                    this.$delete(this.filters.tags, position);
                }
            },
            clearAllTags: function () {
                this.filters.tags = [];
            },
            changeKeywords: function (value) {
                this.filters.keywords = value;
                this.updateQueryString("keywords", value);
            },
            changeFavourites: function (value) {
                this.filters.favourites = value;
                this.updateQueryString("favourites", value);
            },
            changeCustomImage: function (value) {
                this.filters.customImage = value;
                this.updateQueryString("customImage", value);
            },
            changeCustomText: function (value) {
                this.filters.customText = value;
                this.updateQueryString("customText", value);
            },
            dismissPopup: function () {
                const popupState = JSON.parse(window.localStorage.getItem("popupState")) || [];
                if (this.metaData && !popupState.includes(this.metaData.alias)) {
                    popupState.push(this.metaData.alias);
                }
                window.localStorage.setItem("popupState", JSON.stringify(popupState));
            },
            updateQueryString: function (param, value) {
                const searchParams = new URLSearchParams(window.location.search);
                if (value) {
                    searchParams.set(param, value);
                } else {
                    searchParams.delete(param);
                }
                window.history.replaceState(this.filters, null, "?" + searchParams.toString());
            }
        },
        mounted: function () {
            this.loadFilters();
        },
        components: {
            autocomplete,
            filterButton,
            multiSelect,
            singleSelect,
            tagList,
            tooltip
        }
    };
</script>